import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import { active, item, itemWrapper } from "./ListNav.module.scss";

const ListNavItem = ({ children, ...props }) => (
  <li>
    <NavLink {...props} activeClassName={active} className={item}>
      <div className={itemWrapper}>
        {children}
      </div>
    </NavLink>
  </li>
);

ListNavItem.propTypes = {
  children: PropTypes.node
};

ListNavItem.defaultProps = {
  children: null
};

export default ListNavItem;
